import React, { useState } from 'react';
import '../Components/ComponentCss/Registration_body1.css';
import axios from "axios";
import config from "../ip.json";
import Swal from "sweetalert2"; // CSS 파일 임포트

const Registration_body1 = ({companyList}) => {
    // 상태 변수 선언
    const [companyName, setCompanyName] = useState('');
    const [entryDate, setEntryDate] = useState('');
    const [businessNumber, setBusinessNumber] = useState('');
    const [representative, setRepresentative] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [corporation, setCorporation] = useState(false);

    // 각 입력 필드에 대한 onChange 핸들러
    const handleCompanyNameChange = (e) => {
        let name = e.target.value;
        if (corporation && !name.startsWith('(주) ')) {
            name = '(주) ' + name;
        } else if (!corporation && name.startsWith('(주) ')) {
            name = name.replace('(주) ', '');
        }
        setCompanyName(name);
    };

    const handleEntryDateChange = (e) => {
        const rawDate = e.target.value; // YYYY-MM-DD 형식
        const isoDate = new Date(rawDate).toISOString(); // ISO 형식으로 변환
        setEntryDate(isoDate);
    };    const handleBusinessNumberChange = (e) => setBusinessNumber(e.target.value);
    const handleRepresentativeChange = (e) => setRepresentative(e.target.value);
    const handlePhoneNumberChange = (e) => setPhoneNumber(e.target.value);

    const handleCheckChange = () => {
        setCorporation(!corporation);
        // 체크박스 상태 변경에 따라 companyName 값 업데이트
        setCompanyName((prevName) => {
            if (!corporation && !prevName.startsWith('(주) ')) {
                return '(주) ' + prevName;
            } else if (corporation && prevName.startsWith('(주) ')) {
                return prevName.replace('(주) ', '');
            }
            return prevName;
        });
    };

    const data = () => ({
        company: companyName,
        boss: representative,
        certificate: businessNumber,
        phoneNumber: phoneNumber,
        corporate: corporation,
        registrationDate: entryDate,

    });


    const handleRegistration = async () => {
        try {
            const response = await axios.post(
                `${config.url}/v2/company/add`,
                data(),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true,
                }
            );
            if (response.data === '등록되었습니다.') {
                업체등록성공();

            }
        } catch (error) {
            console.error('Error fetching data:', error);
            업체등록실패(error.response?.data || '오류 발생');
        }
        setTimeout(() => {
            window.location.reload();
        }, 1000); // 1초 딜레이
    };

    const 업체등록성공 = () => {
        Swal.fire({
            title: "업체가 등록되었습니다!",
            icon: "success"
        });
    };

    const 업체등록실패 = (text) => {
        Swal.fire({
            title: text.toString(),
            icon: "error"
        });
    };

    return (
        <div className="registration-body1">
            <div className="topspace">
                <div className="topspace-add-input-component_1">
                    <div className="topspace-add-input-component-title">업체명</div>
                    <label className="topspace-container">
                        <input
                            type="checkbox"
                            checked={corporation}
                            onChange={handleCheckChange}
                        />
                        <div className="topspace-checkmark"></div>
                    </label>
                    <div className="topspace-remember">법인기업</div>
                    <div className="topspace-input-pay_1">
                        <input
                            type="text"
                            placeholder="업체명을 입력해주세요."
                            value={companyName}
                            onChange={handleCompanyNameChange}
                        />
                    </div>
                </div>

                <div className="topspace-add-input-component">
                    <div className="topspace-add-input-component-title">입주일자</div>
                    <div className="topspace-input-pay">
                        <input
                            type="date"
                            placeholder="예) YYYY/MM/DD"
                            value={entryDate ? entryDate.split('T')[0] : ''} // ISO → YYYY-MM-DD
                            onChange={handleEntryDateChange}
                            className="date-input_a"
                        />

                    </div>
                </div>
            </div>

            <div className="middlespace">
                <div className="topspace-add-input-component_1">
                    <div className="topspace-add-input-component-title">사업자번호</div>
                    <div className="topspace-input-pay_1">
                        <input
                            type="text"
                            placeholder="사업자번호를 입력해주세요."
                            value={businessNumber}
                            onChange={handleBusinessNumberChange}
                        />
                    </div>
                </div>

                {/*<div className="topspace-add-input-component">*/}
                {/*    <div className="topspace-add-input-component-title">보증금</div>*/}
                {/*    <div className="topspace-input-pay">*/}
                {/*        <input*/}
                {/*            type="text"*/}
                {/*            placeholder="예) 1,300,000"*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>

            <div className="bottomespace">
                <div className="topspace-add-input-component_2">
                    <div className="topspace-add-input-component-title">대표자</div>
                    <div className="topspace-input-pay_2">
                        <input
                            type="text"
                            placeholder="예) 홍길동"
                            value={representative}
                            onChange={handleRepresentativeChange}
                        />
                    </div>
                </div>

                <div className="topspace-add-input-component_3">
                    <div className="topspace-add-input-component-title">전화번호</div>
                    <div className="topspace-input-pay_3">
                        <input
                            type="text"
                            placeholder="예) 010-1234-5678"
                            value={phoneNumber}
                            onChange={handlePhoneNumberChange}
                        />
                    </div>
                </div>
            </div>

            <div className="registration-button1" onClick={handleRegistration}>
                등록
            </div>
        </div>
    );
};

export default Registration_body1;